import dynamic from "next/dynamic";
const CategorySection = dynamic(
  () => import("@Components/Pages/Landing/CategorySection"),
  { ssr: false }
);
import HeroBanner from "@Components/Pages/Landing/HeroBanner";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import { NextPage } from "next";
import React, { useContext, useEffect, useState } from "react";
import MobileCategoryHeader from "@Components/Layout/Header/MobileCategorySection";
import { AllDynamicContext } from "@Pages/index";
import { ICms } from "@Interfaces/Api/cms/Banner";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch } from "react-redux";
import { CartActions } from "@Redux-Store/Actions";
import Script from "next/script";

const Landing: NextPage = () => {
  const theme = useTheme();
  const allDynamicData = useContext<ICms[]>(AllDynamicContext) || [];
  const dispatch = useDispatch();

  const content = allDynamicData[0] || {};
  const allBanners = content.banner || [];
  const headerNotification = content.headerNotification || [];
  const footerNotification = content.footerNotification || [];

  const [showFooterNotification, setShowFooterNotification] = useState<boolean>(
    false
  );

  useEffect(() => {
    if (headerNotification.length > 0) {
      dispatch(CartActions.setHeaderNotification(headerNotification));
    }
  }, [dispatch, headerNotification]);

  const xsToSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));

  return (
    <Box>
      <Script
        id="schema-org-website"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "@id": "https://www.econut.store/#website",
            "url": "https://www.econut.store/",
            "name": "Econut",
            "description": "Econut offers premium natural products including A2 ghee, cold pressed oils and wellness essentials.",
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.econut.store/#organization"
            }
          }
          ),
        }}
      />
      <Script
        id="schema-org-webpage"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://www.econut.store/#webpage",
            "url": "https://www.econut.store/",
            "name": "Econut",
            "description": "Shop premium natural products including A2 ghee, cold pressed oils and wellness essentials at Econut.",
            "isPartOf": {
              "@type": "WebSite",
              "@id": "https://www.econut.store/#website"
            },
            "about": {
              "@type": "Organization",
              "@id": "https://www.econut.store/#organization"
            }
          }
          ),
        }}
      />
      <MobileCategoryHeader />
      <HeroBanner homePage={true} allBanners={allBanners} />
      <CategorySection />

      <Box
        sx={{
          position: "fixed",
          bottom: { sm: "15px", xs: "20px" },
          zIndex: "2",
          left: { sm: "10px", xs: "0px" },
          borderRadius: "0",
        }}
      >
        {footerNotification.map((val, index) => (
          <React.Fragment key={index}>
            {xsToSm ? (
              <Button
                variant="contained"
                sx={{
                  borderRadius: "0 50px 50px 0px",
                  padding: "0.5rem",
                  fontSize: "0.65rem",
                }}
              >
                <LocalShippingIcon
                  sx={{
                    marginRight: showFooterNotification ? "1rem" : "0rem",
                  }}
                  onClick={() =>
                    setShowFooterNotification((prevVal) => !prevVal)
                  }
                />
                {showFooterNotification ? val : ""}
              </Button>
            ) : (
              <Button
                variant="contained"
                sx={{
                  borderRadius: { sm: "50px", xs: "0 50px 50px 0px" },
                  padding: "0.8rem",
                }}
              >
                <LocalShippingIcon sx={{ marginRight: "1rem" }} />
                {val}
              </Button>
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default React.memo(Landing);
